import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class DebarkationImportedService extends ApiService {
  constructor(private http: Http) {
    super('api/imported-debarkations/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/debarkation-imported.service.ts